import Profile from "./pages/profile/Profile";
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from "./pages/Forms/Login";
import Register from "./pages/Forms/Register";
import Home from "./pages/home/Home";
import Sharepost from "./pages/sharepost/Sharepost";
import Menu from "./components/menu/Menu";
import Notification from "./pages/notification/Notification";
import FriendsRequest from "./pages/friend/FriendsRequest";
import Feedback from "./components/feedback/Feedback";
import Update from "./pages/updateProfile/Update";
import { useState, useEffect } from "react";
import Error from "./pages/errorPage/Error";
import SinglePost from "./pages/singlepost/SinglePost";
import ResetPassword from "./pages/forgetPassword/ResetPassword";
import ForgotPassword from "./pages/forgetPassword/ForgotPassword";
import Error2 from "./pages/errorPage/Error2";
import Messanger from "./pages/messanger/Messanger";


function App() {
  const [isloading, setisloading] = useState(false);

  useEffect(() => {
    setisloading(true);
    setTimeout(() => {
      setisloading(false);
    }, 3000);
  }, [])

  return (
    <>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Home />} />
          <Route path="/profile/:userID" element={<Profile />} />
          <Route path="/share" element={<Sharepost />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/friends" element={<FriendsRequest />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="updateprofile" element={<Update/>} />
          <Route path="notifications/:userID" element={<Notification/>} />
          <Route path="singlepost/:postid" element={<SinglePost/>}/>
          <Route path="messanger" element={<Messanger/>}/>
          
          <Route path="reset-password" element={<ResetPassword/>}/>
          <Route path="forgotpassword/:id/:token" element={<ForgotPassword/>}/>
          <Route path="*" element={<Error/>} />
          <Route path="linkexpire" element={<Error2/>} />
        </Routes>
    </>
  )
}

export default App;